import { cssBorderRadius, focusGapBorder } from "../../styles/index.mjs";
import styled, { css } from "../../styled-components.mjs";
export var StyledTabPanel = styled.div.withConfig({
  displayName: "TabPanel__StyledTabPanel",
  componentId: "sc-fifj60-0"
})(["", ""], function (_ref) {
  var $isUsingKeyboard = _ref.$isUsingKeyboard,
    $useBrowserDefaultFocusStyle = _ref.$useBrowserDefaultFocusStyle;
  return css(["", ";"], !$useBrowserDefaultFocusStyle && focusGapBorder(cssBorderRadius('larger-2', '8px'), $isUsingKeyboard));
});